"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateNotificationPresetRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class CreateNotificationPresetRequestDto {}
exports.CreateNotificationPresetRequestDto = CreateNotificationPresetRequestDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CreateNotificationPresetRequestDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: true
}), __metadata("design:type", Boolean)], CreateNotificationPresetRequestDto.prototype, "enabled", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetTrigger
}), __metadata("design:type", String)], CreateNotificationPresetRequestDto.prototype, "trigger", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetVariant
}), __metadata("design:type", String)], CreateNotificationPresetRequestDto.prototype, "variant", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Minutes after signup before this preset is eligible.'
}), __metadata("design:type", Number)], CreateNotificationPresetRequestDto.prototype, "delayMinutes", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: 0
}), __metadata("design:type", Number)], CreateNotificationPresetRequestDto.prototype, "sortOrder", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: 0,
  description: 'Higher values win when multiple presets share a trigger. The first preset in descending priority order that passes minCount is sent.'
}), __metadata("design:type", Number)], CreateNotificationPresetRequestDto.prototype, "priority", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationPresetVenuePresence,
  required: false,
  default: enums_1.NotificationPresetVenuePresence.Any,
  description: 'Required recipient check-in state relative to the venue referenced by the notification.'
}), __metadata("design:type", String)], CreateNotificationPresetRequestDto.prototype, "venuePresence", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], CreateNotificationPresetRequestDto.prototype, "messageTemplate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.NotificationType,
  required: false
}), __metadata("design:type", String)], CreateNotificationPresetRequestDto.prototype, "notificationType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], CreateNotificationPresetRequestDto.prototype, "minCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], CreateNotificationPresetRequestDto.prototype, "deepLinkTarget", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, mobile may bypass the daily notification frequency cap for this preset.'
}), __metadata("design:type", Boolean)], CreateNotificationPresetRequestDto.prototype, "exemptFromDailyFrequencyCap", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, each send is written to server logs for debugging.'
}), __metadata("design:type", Boolean)], CreateNotificationPresetRequestDto.prototype, "shouldLogSends", void 0);
//# sourceMappingURL=CreateNotificationPresetRequest.dto.js.map